import api from '../api';

export const getAllProbationReviews = async () => {
  const response = await api.get('/probation-reviews');
  return response.data;
};

export const getProbationReviewById = async (id) => {
  const response = await api.get(`/probation-reviews/${id}`);
  return response.data;
};

export const getProbationReviewByContractId = async (contractId) => {
  const response = await api.get(`/probation-reviews/contract/${contractId}`);
  return response.data;
};

export const updateProbationReview = async (id, data) => {
  const response = await api.put(`/probation-reviews/${id}`, data);
  return response.data;
};

export const deleteProbationReview = async (id) => {
  const response = await api.delete(`/probation-reviews/${id}`);
  return response.data;
};

export const backfillProbationReviews = async () => {
  const response = await api.post('/probation-reviews/backfill');
  return response.data;
};

export const hasIncompleteReviews = async () => {
  const response = await api.get('/probation-reviews/has-incomplete');
  return response.data;
};